import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const skeleton: {
  defaultProps?: ComponentsProps['MuiSkeleton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSkeleton'];
  variants?: ComponentsVariants<Theme>['MuiSkeleton'];
} = {
  styleOverrides: {
    root() {
      return {
        transform: 'none'
      };
    }
  }
};
